// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig :{
    apiKey: "AIzaSyC_Sw0oEXCNNztmf9CGwhzGsVlhV67ssWI",
    authDomain: "isfreeroom.firebaseapp.com",
    databaseURL: "https://isfreeroom-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "isfreeroom",
    storageBucket: "isfreeroom.appspot.com",
    messagingSenderId: "574972255228",
    appId: "1:574972255228:web:ee4b2d0f7c9e193daa7079",
    measurementId: "G-JJPJ286P87"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
